import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Container } from './styles';

interface ModalJobVacancyProps {
  showModal: boolean;
  dadosCurriculo: {
    curriculos_nome: string;
    curriculos_vaga: string;
    curriculos_formacao: string;
    curriculos_especializacao: string;
    curriculos_experiencia: string;
    curriculos_observacoes: string;
    curriculos_email: string;
    curriculos_celular: string;
    curriculos_telefone: string;
    curriculos_cidade: string;
  };
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  estado: any;
}

const ModalJobVacancy = (props: ModalJobVacancyProps) => {
  const { showModal, dadosCurriculo, setShowModal, estado } = props;
  const formatPhone = (phone: string) => {
    if (!phone) return '';
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    if (cleaned.length === 11) {
      return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    return phone;
  };
  return (
    <Modal size="lg" show={showModal}>
      <Container>
        <div className="row">
          <div className="col-md-12">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title font-weight-bold">Detalhes do currículo</h5>
                <button type="button" className="close" onClick={() => setShowModal(false)}>
                  <span>x</span>
                </button>
              </div>
              <div className="modal-body mt-3 dados-modal">
                <div className="row">
                  <div className="col-md-6">
                    <h4>{dadosCurriculo.curriculos_nome}</h4>
                    <hr />
                    <h5>Vaga Pretendida</h5>
                    <p>{dadosCurriculo.curriculos_vaga}</p>
                    <h5>Formação Acadêmica</h5>
                    <p>{dadosCurriculo.curriculos_formacao}</p>
                    <h5>Especialização</h5>
                    <p>{dadosCurriculo.curriculos_especializacao}</p>
                    <h5>Experiência Profissional</h5>
                    <p>{dadosCurriculo.curriculos_experiencia}</p>
                    <h5>Observações</h5>
                    <p>{dadosCurriculo.curriculos_observacoes}</p>
                  </div>
                  <div className="col-md-6 dados-de-contato">
                    <h5>Dados de Contato</h5>
                    <ul>
                      <li>
                        <strong>E-mail: </strong>
                        {dadosCurriculo.curriculos_email}
                      </li>
                      <li>
                        <strong>Telefone: </strong>
                        {formatPhone(dadosCurriculo.curriculos_telefone)}
                      </li>
                      <li>
                        <strong>Celular: </strong>
                        {formatPhone(dadosCurriculo.curriculos_celular)}
                      </li>
                    </ul>
                    <h5>Dados de Contato</h5>
                    <ul>
                      <li>
                        <strong>Cidade: </strong>
                        {dadosCurriculo.curriculos_cidade}
                      </li>
                      <li>
                        <strong>Estado: </strong>
                        {estado}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 text-right mt-3">
                    <button
                      type="button"
                      className="btn btn-secondary mr-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalJobVacancy;
